// extracted by mini-css-extract-plugin
export default {"profile":"profile__4j18o","tech":"tech__HqIBl"};